__turbopack_context__.v({
  "align-center": "Heading-module-scss-module__Dbxmxa__align-center",
  "align-left": "Heading-module-scss-module__Dbxmxa__align-left",
  "align-right": "Heading-module-scss-module__Dbxmxa__align-right",
  "heading": "Heading-module-scss-module__Dbxmxa__heading",
  "line-height-loose": "Heading-module-scss-module__Dbxmxa__line-height-loose",
  "line-height-normal": "Heading-module-scss-module__Dbxmxa__line-height-normal",
  "line-height-relaxed": "Heading-module-scss-module__Dbxmxa__line-height-relaxed",
  "line-height-snug": "Heading-module-scss-module__Dbxmxa__line-height-snug",
  "line-height-tight": "Heading-module-scss-module__Dbxmxa__line-height-tight",
  "size-2xl": "Heading-module-scss-module__Dbxmxa__size-2xl",
  "size-3xl": "Heading-module-scss-module__Dbxmxa__size-3xl",
  "size-4xl": "Heading-module-scss-module__Dbxmxa__size-4xl",
  "size-5xl": "Heading-module-scss-module__Dbxmxa__size-5xl",
  "size-lg": "Heading-module-scss-module__Dbxmxa__size-lg",
  "size-md": "Heading-module-scss-module__Dbxmxa__size-md",
  "size-sm": "Heading-module-scss-module__Dbxmxa__size-sm",
  "size-xl": "Heading-module-scss-module__Dbxmxa__size-xl",
  "weight-bold": "Heading-module-scss-module__Dbxmxa__weight-bold",
  "weight-medium": "Heading-module-scss-module__Dbxmxa__weight-medium",
  "weight-normal": "Heading-module-scss-module__Dbxmxa__weight-normal",
  "weight-semibold": "Heading-module-scss-module__Dbxmxa__weight-semibold",
  "weight-snug": "Heading-module-scss-module__Dbxmxa__weight-snug",
});
